import { vnModule_knockoutJS } from '../../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS';
import { XMLHttpRequestHandler } from '../../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler';
import { vn_app_zone_notification } from '../../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification';
import { header } from '../header';
import { adminTransmissionEdit_template } from '../../components/templates/recruiting/adminTransmissionEdit_template';
import { hideLoadingOverlay, showLoadingOverlay } from '~/utils/listLoading';
export class admin_transmission_edit extends vnModule_knockoutJS {
    constructor() {
        super(...arguments);
        this.references = {};
        this.agenciesRequest = null;
    }
    /**
     * Return the module key used by the Valnet app framework.
     *
     * @return string
     */
    getModuleName() {
        return 'admin_transmission_edit';
    }
    /**
     * Build and return the DOM content for this module.
     *
     * @return Array<Element>
     */
    buildContent() {
        const zoneHeader = this.getVnAppZone().app.getZoneByName('Header');
        const loadedModule = zoneHeader.loadedModule;
        loadedModule.setHeaderTitle('Transmission');
        this.tpl = new adminTransmissionEdit_template('adminTransmissionEditTemplate', this.viewModel, this);
        this.template = this.tpl;
        return [this.tpl.build()];
    }
    /**
     * Load the initial data required by the page.
     *
     * @return void
     */
    fillPage() {
        showLoadingOverlay(this.tpl.builtTemplate, 'Loading transmission...');
        this.loadReference('/api/admin/rest/api/lead/transmission/types', 'types', () => {
            this.loadReference('/api/admin/rest/api/lead/transmission/channels', 'channels', () => {
                this.loadReference('/api/admin/rest/api/lead/transmission/customizationPresets', 'customizationPresets', () => {
                    this.loadReference('/api/admin/rest/api/lead/transmission/scheduling/groups', 'groups', () => {
                        this.loadReference('/api/admin/rest/api/lead/tracking/partners', 'partnerReferences', () => {
                            this.tpl.setReferences(this.references);
                            this.loadTransmission();
                        });
                    });
                });
            });
        });
    }
    /**
     * Load reference data from the API.
     *
     * @param url string
     * @param target string
     * @param done Function
     * @return void
     */
    loadReference(url, target, done) {
        const req = new XMLHttpRequestHandler(url, [], this);
        req.onReadyStateFunction = function (request, obj) {
            return function () {
                obj.manageResponse(request, obj, function () {
                    obj.references[target] = JSON.parse(request.request.response || '[]');
                    done();
                });
            };
        };
        req.execute();
    }
    /**
     * Load agencies for the selected transmission channel.
     */
    loadAgencies(channel) {
        const selectedChannel = String(channel || this.tpl.getTemplateViewModel().channel() || '').trim();
        if (!selectedChannel) {
            this.tpl.setAgencies([]);
            return;
        }
        if (this.agenciesRequest) {
            this.agenciesRequest.cancelAndReset();
        }
        this.agenciesRequest = new XMLHttpRequestHandler('/api/admin/rest/api/lead/transmission/agencies/' + encodeURIComponent(selectedChannel), [], this);
        this.agenciesRequest.onReadyStateFunction = this.onAgenciesReturn;
        this.agenciesRequest.execute();
    }
    /**
     * Handle the API response for agencies.
     */
    onAgenciesReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.tpl.setAgencies(JSON.parse(req.request.response || '[]'));
            });
        };
    }
    /**
     * Load transmission data from the API.
     *
     * @return void
     */
    loadTransmission() {
        const id = this.getTransmissionId();
        if (!id) {
            this.tpl.setTransmission({
                live: 1,
                channel: 'REC',
                partnerIds: [],
                transmissionGroups: [],
            });
            hideLoadingOverlay(this.tpl.builtTemplate);
            return;
        }
        this.XHRHdl = new XMLHttpRequestHandler('/api/admin/rest/api/lead/transmission/' + id, [], this);
        this.XHRHdl.onReadyStateFunction = this.onTransmissionReturn;
        this.XHRHdl.execute();
    }
    /**
     * Handle the API response for transmission.
     *
     * @param req any
     * @param obj any
     * @return () => void
     */
    onTransmissionReturn(req, obj) {
        return function () {
            obj.manageResponse(req, obj, function () {
                obj.tpl.setTransmission(JSON.parse(req.request.response || '{}'));
            });
            if (req.request.readyState === 4 && req.request.status !== 0) {
                hideLoadingOverlay(obj.tpl.builtTemplate);
            }
        };
    }
    /**
     * Save transmission through the API.
     *
     * @return Promise<void>
     */
    async saveTransmission() {
        const payload = this.tpl.getPayload();
        if (!payload.name) {
            alert('Transmission name is required.');
            return;
        }
        if (!payload.transmissionType) {
            alert('Transmission type is required.');
            return;
        }
        showLoadingOverlay(this.tpl.builtTemplate, 'Saving transmission...');
        const response = await fetch('/api/admin/rest/api/lead/transmission', {
            method: 'POST',
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(payload),
        });
        const result = await response.json();
        hideLoadingOverlay(this.tpl.builtTemplate);
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || 'Unable to save transmission.');
            return;
        }
        page('/admin/transmission/' + result.objectId);
    }
    /**
     * Handle run transmission.
     *
     * @return Promise<void>
     */
    async runTransmission() {
        const id = this.getTransmissionId();
        if (!id) {
            alert('Save the transmission before running it.');
            return;
        }
        const response = await fetch('/api/admin/rest/api/lead/transmission/run/' + id, {
            method: 'POST',
            credentials: 'same-origin',
        });
        const result = await response.json();
        if (!response.ok || Number(result.status || 0) !== 200) {
            alert(result.message || 'Unable to queue transmission task.');
            return;
        }
        this.validationTemplate.clearMessages();
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_SUCCESS, this.formatQueuedTaskMessage(result, 'Transmission task queued.'));
    }
    /**
     * Navigate back to transmissions.
     *
     * @return void
     */
    backToTransmissions() {
        page('/admin/transmissions');
    }
    /**
     * Return transmission id.
     *
     * @return number
     */
    getTransmissionId() {
        const id = this.getVnAppZone().app.params.id;
        return id && id !== 'new' ? Number(id) : 0;
    }
    /**
     * Build a success message that includes queued task details.
     *
     * @param result any
     * @param fallback string
     * @return string
     */
    formatQueuedTaskMessage(result, fallback) {
        const details = [];
        if (result.taskId) {
            details.push('Task #' + result.taskId);
        }
        if (result.operation) {
            details.push('operation ' + result.operation);
        }
        return details.length ? fallback + ' ' + details.join(', ') + '.' : (result.message || fallback);
    }
}
